import OverlayScrollbars from 'overlayscrollbars';

export default () => {
  let isTouchDevice = !document.querySelector('html').classList.contains('no-touchevents');
  if (isTouchDevice) {
    OverlayScrollbars(document.querySelectorAll('.styled-touch-scrollbar.scrollbar-for-touch-devices'), {})
  }
}

